import React from 'react';
import '../../styles/Dashboard.css';
import BillList from './BillList';

const Bills = () => {
  return (
    <div className="section dashboard-container">
      <BillList />
    </div>
  );
};

export default Bills;
